import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Contrato } from '../modelo/contrato';
import { Endereco } from '../modelo/endereco';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-endereco-conclusao',
  templateUrl: './endereco-conclusao.component.html',
  styleUrls: ['./endereco.component.css']
})
export class EnderecoConclusaoComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;
  endereco: string;
  veioSegundaViaCarne: string = 'N';
  mensagem: string;

  constructor(
    private router: Router,
    private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);

    this.contrato = JSON.parse(sessionStorage.getItem('contrato'));
    this.endereco = JSON.parse(sessionStorage.getItem('endereco'));
    this.veioSegundaViaCarne = sessionStorage.getItem('veioSegundaViaCarne');
    this.mensagem = this.endereco;

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  retornarSegundaViaCarne() {
    sessionStorage.setItem('segundaViaContrato', JSON.stringify(this.contrato));
    this.router.navigate(['/BF-Portal/segundaviacarneEndereco']);
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-endereco-cli/endereco-conclusao.component.ts